module.exports = __webpack_public_path__ + "static/media/hardware3.2bea0ed7.png";